import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { resolvePostAuthPath, type PostAuthUser } from '../utils/postAuthNavigation';

interface VerifiedUserLandingRedirectProps {
  user: PostAuthUser;
}

/**
 * Resolves dashboard vs onboarding before navigating verified users away from public routes.
 */
export const VerifiedUserLandingRedirect: React.FC<VerifiedUserLandingRedirectProps> = ({
  user,
}) => {
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    resolvePostAuthPath(user).then(path => {
      if (!cancelled) {
        setTarget(path);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user.isAdmin, user.emailVerified]);

  if (!target) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading…</p>
        </div>
      </div>
    );
  }

  return <Navigate to={target} replace />;
};
